import gql from 'graphql-tag';

export default gql`
  query getReservation($id: Int) {
    getReservation(id: $id) {
      total
      pickupCity
      pickupState
      pickupStreet
      pickupBuildingName
      pickupZipcode
      returnCity
      returnState
      returnStreet
      returnBuildingName
      returnZipcode
      units
      unitType
      listData {
        category
        category2
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mobxStores/Inbox/getReservationQ.js